import React, { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-apollo";

import { Fieldset } from "rbx";
import { EditFormButtonGroup } from "../inputs";

import Section from "../Section";

import {
  UPDATE_HOLIDAY_MUTATION,
  DELETE_HOLIDAY_MUTATION
} from "../../graphql/Holidays/Holidays.graphql";

import { ourToast as toast } from "../../utils";

import HolidayForm from "./HolidayForm";

const INITIAL_STATE = {
  HolidayDate: "",
  HolidayDescription: ""
};

const EditHolidayForm = ({ holiday, onComplete }) => {
  const [inputs, setInputs] = useState({ ...INITIAL_STATE, ...holiday });
  const handleChange = e => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };
  const [updateHoliday, { loading }] = useMutation(UPDATE_HOLIDAY_MUTATION, {
    refetchQueries: ["ALL_HOLIDAYS_QUERY"]
  });

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      await updateHoliday({
        variables: {
          data: {
            ...obj,
            HolidayDate: inputs.HolidayDate
              ? new Date(inputs.HolidayDate).setUTCHours(13)
              : ""
          },
          where: { RecId: parseInt(holiday.RecId) }
        }
      });
      toast.success("Holiday updated successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error updating Holiday.");
    }
  };
  return (
    <Section title="Edit Holiday">
      <form id="edit-holiday-form" onSubmit={handleSubmit}>
        <Fieldset disabled={loading}>
          <HolidayForm inputs={inputs} onChange={handleChange} />
          <EditFormButtonGroup
            deleteMutation={DELETE_HOLIDAY_MUTATION}
            form="edit-holiday-form"
            refetchQueries={["ALL_HOLIDAYS_QUERY"]}
            variables={{ where: { RecId: parseInt(holiday.RecId) } }}
            onComplete={onComplete}
          />
        </Fieldset>
      </form>
    </Section>
  );
};

EditHolidayForm.propTypes = {
  onComplete: PropTypes.func,
  holiday: PropTypes.object
};
export default EditHolidayForm;
